import {Checkbox as ChakraCheckbox, CheckboxProps as ChakraCheckboxProps, Flex, Box, FormLabel, Icon, Tooltip, Text } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";

interface CheckboxProps extends ChakraCheckboxProps {
    infoTooltipLabel?: string;
    infoTooltip?: boolean;
    errors?: any;
    register?: any;
    classInput?: string;
    before?: string;
    after?: string;
    label?: string;
    labelColor?: string;
    ref?: any;
    name?: string;
}

export function Checkbox(
    {
    infoTooltipLabel,
    infoTooltip,
    labelColor,
    label,
    children,
    className,
    classInput,
    ref,
    register,
    errors,
    before,
    after,
    name,
    ...rest
    }: CheckboxProps
) {
    return(
        <Box position="relative">
          <Flex align="center" w="100%" h="100%">
            <ChakraCheckbox
              {...rest}
              {...register}
              name={name}
              borderRadius="2px"
            />
            {label && (
              <FormLabel
                w="100%"
                color={labelColor ? labelColor : "gray.400"}
                fontSize="12px"
                position="absolute"
                top="50%"
                transform="translateY(-50%)"
                left="5"
              >
                {label}
                {infoTooltip && (
                  <Tooltip placement="top" hasArrow label={infoTooltipLabel}>
                    <span>
                      <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                    </span>
                  </Tooltip>
                )}
              </FormLabel>
          )}
          </Flex>
          {errors && (
            <Text color="danger" mb="4" role="alert">
              {errors.message}
            </Text>
          )}
        </Box>
      );
}